import { Api, query } from 'lib/api.mjs';

/** Custom reports and the intraday feed. */

/**
 * A date-ranged report. `accounts` is a comma-separated list of ad account
 * names (or act_ ids); leave it out for every registered account, archived
 * included — these are period figures, and archiving does not un-happen a week.
 *
 * @param {{ since: string, until: string, level?: 'account'|'campaign', accounts?: string }} payload
 */
export function getInsights({ since, until, level = 'account', accounts, stores, signal }) {
  return Api.get(`/insights${query({ since, until, level, accounts, stores: stores ? 1 : undefined })}`, { signal });
}

/**
 * Hourly buckets for a single day. Only today and yesterday are covered — the
 * endpoint has no history beyond that.
 *
 * `account` takes "all" or a comma-separated list of names / act_ ids, matching
 * the `accounts` filter on getInsights — the two feed the same report and must
 * be able to describe the same selection.
 *
 * @param {{ day?: 'today'|'yesterday', view?: string, account?: string }} [payload]
 */
export function getIntraday({ day = 'today', view = 'account', account = 'all', signal } = {}) {
  return Api.get(`/intraday${query({ day, view, account })}`, { signal });
}
